module.exports = __webpack_public_path__ + "static/media/17.e35f2a66.JPG";